import { ViewColumnState } from "../../../../../application-controller/store/states/view-col.states";

export interface AgingPeriodViewCacheState {
  agingPeriod: ViewColumnState;
}

export const initialState: AgingPeriodViewCacheState = {
  agingPeriod: null,
};
